import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expander-opened",
  "use": "expander-opened-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"expander-opened\">\n        <circle class=\"expander-circle\" cx=\"16\" cy=\"16\" r=\"15.5\" fill=\"none\" stroke=\"var(--action-color, var(--accent-blue-600))\" />\n        <path class=\"expander-inner\" d=\"M4 8.5H14V9.5H4z\" transform=\"translate(7 7)\" fill=\"var(--action-color, var(--accent-blue-600))\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol